module.exports = __webpack_public_path__ + "static/media/400395_02.45a5fb34.png";